function ViewerFormat() {
  return (
    <svg width='20' height='19' viewBox='0 0 20 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M16 0.75H4C1.582 0.75 0.25 2.082 0.25 4.5V14.5C0.25 16.918 1.582 18.25 4 18.25H16C18.418 18.25 19.75 16.918 19.75 14.5V4.5C19.75 2.082 18.418 0.75 16 0.75ZM1.75 14.5V4.5C1.75 2.923 2.423 2.25 4 2.25H9.25V16.75H4C2.423 16.75 1.75 16.077 1.75 14.5ZM18.25 14.5C18.25 16.077 17.577 16.75 16 16.75H10.75V2.25H16C17.577 2.25 18.25 2.923 18.25 4.5V14.5Z'
        fill='#0066FF'
      />
    </svg>
  );
}

export default ViewerFormat;
